import { Outlet } from "react-router-dom";

const FullPageLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default FullPageLayout;
